export const setTextFilter = (text = '') => ({
  type: 'SET_EXPENSE_TEXT_FILTER',
  text
});

export const setExcludeTypeFilter = (excludeType = '') => ({
  type: 'SET_EXPENSE_EXCLUDE_TYPE_FILTER',
  excludeType
});

export const sortByAmount = () => ({
  type: 'SORT_EXPENSE_BY_AMOUNT'
});

export const sortByDate = () => ({
  type: 'SORT_EXPENSE_BY_DATE'
});

export const setStartDate = (date) => ({
  type: 'SET_EXPENSE_START_DATE',
  date
});

export const setEndDate = (date) => ({
  type: 'SET_EXPENSE_END_DATE',
  date
});